export default __webpack_public_path__ + "static/media/product-08 (2).64bb6c0f.jpg";